import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ecomm-services.css';

export default function EcommServices() {
    return (
        <section className="ecomm-services-wrapper">
            <Container>
                <div className="ecomm-dev-section cro-reveal">
                    <div className="ecomm-dev-header">
                        <span className="ecomm-dev-label">E-commerce Store Development</span>
                        <h3 className="ecomm-dev-title">
                            Launch your store on the world's <span className="highlight">top platforms</span>
                        </h3>
                        <p className="ecomm-dev-subtitle">
                            We build high-converting, fully customized eCommerce stores on Shopify and WooCommerce — tailored to your brand and optimized for revenue growth.
                        </p>
                    </div>
                    <Row className="justify-content-center">
                        <Col lg={5} md={6} className="mb-4">
                            <div className="cro-service-card cro-reveal cro-delay-1">
                                <div className="ecomm-clean-header" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '14px' }}>
                                    <div className="ecomm-logo-box" style={{ width: '50px', height: '50px', borderRadius: '12px', background: 'rgba(150, 191, 72, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={require('../../asstes/shopify-icon.svg').default} alt="Shopify" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
                                    </div>
                                    <h3 style={{ marginBottom: 0 }}>Shopify Store</h3>
                                </div>
                                <p className="service-desc">
                                    Craft a stunning, high-converting Shopify store tailored to your brand. We handle everything from theme customization to app integrations and full launch.
                                </p>
                                <ul className="cro-service-features">
                                    <li>Custom theme design &amp; development</li>
                                    <li>Product listings &amp; collection setup</li>
                                    <li>Payment &amp; shipping configuration</li>
                                    <li>SEO optimization &amp; Google Analytics</li>
                                    <li>Mobile-first responsive design</li>
                                    <li>Shopify Apps &amp; integrations</li>
                                </ul>
                                <Link to="/shopify" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'underline', color: 'var(--Brand-Primary-bg)', fontWeight: '600', fontSize: '15px' }}>Learn More</Link>
                            </div>
                        </Col>
                        <Col lg={5} md={6} className="mb-4">
                            <div className="cro-service-card cro-reveal cro-delay-2">
                                <div className="ecomm-clean-header" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '14px' }}>
                                    <div className="ecomm-logo-box" style={{ width: '50px', height: '50px', borderRadius: '12px', background: 'rgba(152, 104, 206, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={require('../../asstes/woocommerce-icon.svg').default} alt="WooCommerce" style={{ width: '28px', height: '28px', objectFit: 'contain' }} />
                                    </div>
                                    <h3 style={{ marginBottom: 0 }}>WooCommerce Store</h3>
                                </div>
                                <p className="service-desc">
                                    Build a powerful WooCommerce store on WordPress — flexible, scalable, and built to grow your brand with seamless payment and shipping integrations.
                                </p>
                                <ul className="cro-service-features">
                                    <li>Custom WordPress &amp; WooCommerce setup</li>
                                    <li>Plugin configuration &amp; customization</li>
                                    <li>Payment gateway &amp; shipping integration</li>
                                    <li>SEO &amp; performance optimization</li>
                                    <li>Responsive &amp; mobile-ready design</li>
                                    <li>Security hardening &amp; SSL setup</li>
                                </ul>
                                <Link to="/woocommerce" style={{ display: 'inline-block', marginTop: '20px', textDecoration: 'underline', color: 'var(--Brand-Primary-bg)', fontWeight: '600', fontSize: '15px' }}>Learn More</Link>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
}
